import { CSSProperties, ReactNode } from 'react';

export interface LottieProps {
  children?: ReactNode;
  slide?: string;
  isPaused?: boolean;
  style?: CSSProperties;
  childrenStyle?: CSSProperties;
}

export const defaultOptions = (animationData: any, className?: string) => ({
  loop: true,
  autoplay: true,
  animationData,
  // canvas fixes square circle issue on safari
  renderer: 'canvas' as const, // 'svg', 'canvas' or 'html'
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
    className,
  },
});

const JSONDictionary = {
  intro: ['intro'],
  blueOrbs: ['blueOrbs'],
  orbs_01: ['cl'],
  orbs_02: ['lg', 'trans'],
  orbs_03: ['dt', 'amaga'],
  orbs_04: ['rr', 'teigen'],
  orbs_05: ['gs'],
  orbs_06: ['pd', 'tpsl-gs', 'fh', 'hs', 'harris2024'],
  orbs_07: ['ng', 'breakingbarriers'],
  orbs_08: ['mx', 'lastmin'],
  orbs_09: ['bb'],
  numbers: ['number1', 'number2', 'number3'],
  vertical_lines: ['vertical_line1', 'vertical_line2', 'vertical_line3', 'vertical_line4'],
  horizontal_lines: [
    'horizontal_line1',
    'horizontal_line2',
    'horizontal_line3',
    'horizontal_line4',
  ],
  hero_module: ['hero_module'],
  quote_module: ['quote_module'],
  contact_module: ['contact_module'],
  impact_ratings_module: ['impact_ratings_module'],
};

export const getJSONFile = (key: string) => {
  for (const [fileName, keys] of Object.entries(JSONDictionary)) {
    if (keys.includes(key)) {
      return fileName;
    }
  }
  return null;
};
